import { modalRenderer } from '~/modal/modalRendererRegistry';
import { WalkthroughModalComponent } from './walkthroughModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    Walkthrough: undefined;
  }
}

modalRenderer.register('Walkthrough', WalkthroughModalComponent);
